import React from "react";

export default function NotFoundPage() {
  return <div>Not Found Page!</div>;
}
